//This function takes the course, absenct lecs number, absent tuts number, the asked question, and it answers accordingly.
import { ICourse } from "../inputForm/courseDataList";
import { calculateAbsense } from "../utlis/computeRemaining";
import { replier } from "./replier";

// Takes the result calculated from the normal absence calculator "utlis/computeRemaining.ts", and 
// parse it; in order to answer the question. Returns 1: you can miss, 0: you can not miss, -1: you are already out of the course
const canIMiss = (results: {lectures: number, tutorials: number}[], lecs?: number, tuts?: number): number => {

  if (results.every(result => result.lectures === -1 && result.tutorials === -1) === true) return -1;

  else if (lecs == 1 && !tuts) {
    if (results.some(result => result.lectures >= lecs) === true) return 1;
  }

  else if (!lecs && tuts == 1) {
    if (results.some(result => result.tutorials >= tuts) === true) return 1;
  }

  else if (lecs == 1 && tuts == 1) {
    if (results.some(result => result.lectures >= lecs && result.tutorials >= tuts) === true) return 1;
  }

  return 0;
}

export const smartAbsenceCalculater = (course?: ICourse, absentLecs?: number, absentTuts?: number, question?: string) => {
  
  if (course !== undefined && absentLecs !== undefined  && absentTuts !== undefined  && question !== undefined) {
    const results = calculateAbsense(course.code, course.credits, absentLecs, absentTuts).possibleCombinations;
    
    if (question === 'CanIMissNextLec') {
      const missResult = canIMiss(results, 1, 0);
      return replier(missResult, 'next lecture', course?.credits, absentLecs, absentTuts, course);
    }

    else if (question === 'CanIMissNextTut') {
      const missResult = canIMiss(results, 0, 1);
      return replier(missResult, 'next tutorial', course?.credits, absentLecs, absentTuts, course);
    }

    else if (question === 'CanIMissNextLecTut') {
      const missResult = canIMiss(results, 1, 1);
      return replier(missResult, 'next lecture and tutorial', course?.credits, absentLecs, absentTuts, course);
    }

    else if (question === 'HowItWorks')  return replier(2, '', course?.credits, undefined, undefined, course);
  }

  // This case if the user asked this question directly. So, absentLecs and absentTuts will be undifiend.
  else {
    if (question === 'HowItWorks')  return replier(2, '', course?.credits, undefined, undefined, course);
  } 
}